module.exports = __webpack_public_path__ + "img/del.13268836.png";